import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function setItem(key, value) {
  return Cookies.set(key, value)
}

export function getItem(key) {
  return Cookies.get(key)
}
export function removeItem(key) {
  return Cookies.remove(key)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js